module.exports = __webpack_public_path__ + "static/8-Dish w_loose flower sculpture-top detail-28cc5e21e1a7d10c2f0621a8a426a578.jpg";